import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaUserMd, FaHeart, FaHospital, FaClinicMedical, FaStethoscope, FaSnowflake, FaVial, FaFemale, FaMale, FaRegClock, FaShieldAlt } from "react-icons/fa";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import WorkingProcess from "../Section/WorkingProcess";
import Spacing from "../Spacing";
import Post from "../Post";
import styled from "styled-components";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import { Helmet } from "react-helmet";

const workingProcessData = [
  {
    title: "Initial Consultation and Assessment",
    subTitle:
      "You can fill out an online appointment form on the website of Pluro Jabalpur Fertility Centre or call our office Number",
    iconUrl: "/images/home_2/department_icon1.png",
    number: "01",
  },
  {
    title: "Ovarian Stimulation (For Egg or Embryo Freezing)",
    subTitle:
      "Baseline bloodwork and an ultrasound are performed to assess your reproductive health. These tests help us create the most effective treatment plan.",
    iconUrl: "/images/home_2/department_icon26.png",
    number: "02",
  },
  {
    title: "Egg Retrieval (For Egg Freezing)",
    subTitle:
      "Ovarian stimulation uses medications to encourage the development of multiple eggs. These eggs are then retrieved for freezing.",
    iconUrl: "/images/home_2/department_icon25.png",
    number: "03",
  },
  {
    title: "Egg Freezing & Maintenance",
    subTitle:
      "The Egg is carefully frozen and stored for future use in IVF or other fertility treatments, ensuring it remains in optimal condition for fertilization.",
    iconUrl: "/images/home_2/department_icon27.png",
    number: "04",
  },
];
const workingProcessData1 = [
  {
    title: "Initial Consultation and Assessment",
    subTitle:
      "You can fill out an online appointment form on the website of Pluro Jabalpur Fertility Centre or call our office Number",
    iconUrl: "/images/home_2/department_icon1.png",
    number: "01",
  },
  {
    title: "Sperm Collection",
    subTitle:
      " A sperm sample is collected and tested to assess quality. This helps us tailor the best fertility treatment plan for you.",
    iconUrl: "/images/home_2//departmentLap4.png",
    number: "02",
  },
  {
    title: "Sperm Freezing & Maintenance",
    subTitle:
      "The sperm is carefully frozen and stored for future use in IVF or other fertility treatments, ensuring it remains in optimal condition for fertilization.",
    iconUrl: "/images/home_2/department_icon27.png",
    number: "03",
  },
];
const workingProcessData2 = [
  {
    title: "Initial Consultation and Assessment",
    subTitle:
      "You can fill out an online appointment form on the website of Pluro Jabalpur Fertility Centre or call our office Number",
    iconUrl: "/images/home_2/department_icon1.png",
    number: "01",
  },
  {
    title: "Ovarian Stimulation",
    subTitle:
      "Baseline bloodwork and an ultrasound are conducted to assess your reproductive health. These tests help us tailor the most effective treatment plan for you, and medications are used to stimulate your ovaries to develop multiple eggs.",
    iconUrl: "/images/home_2/department_icon26.png",
    number: "02",
  },
  {
    title: "Egg Retrieval",
    subTitle:
      "After ovarian stimulation, mature eggs are collected from the ovaries through a minor surgical procedure.",
    iconUrl: "/images/home_2/department_icon25.png",
    number: "03",
  },
  {
    title: "Sperm Collection",
    subTitle: "A sperm sample is collected and prepared for fertilization.",
    iconUrl: "/images/home_2/departmentLap4.png",
    number: "04",
  },
  {
    title: "Ferlization",
    subTitle:
      "The collected eggs are fertilized with sperm in the lab, allowing embryos to develop.",
    iconUrl: "/images/home_2/department_icon6.png",
    number: "05",
  },
  {
    title: "Embryo Freezing & Maintenance",
    subTitle:
      "The developed embryos are carefully frozen and stored for future use. This preserves them in optimal condition for future fertility treatments.",
    iconUrl: "/images/home_2/department_icon27.png",
    number: "06",
  },
];
const relatedBlog = [
  {
    title:
      "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
    thumbUrl: "/images/blog/post_1.jpeg",
    date: "March 12",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },
];
const faqData = [
  {
    title: "What is fertility preservation and who should consider it ?",
    content:
      "Fertility preservation involves storing eggs, sperm, or embryos for future use. It is a valuable option for individuals in various situations, such as cancer patients who need to undergo chemotherapy, radiation, or surgery that could affect their fertility. Women at risk of ovarian failure due to medical conditions or a family history of early menopause might also consider fertility preservation. Individuals with genetic conditions that could impact future fertility, those undergoing gender transition who wish to preserve fertility before hormone therapy or surgery, and people delaying parenthood for personal or professional reasons can all benefit from fertility preservation.",
  },
  {
    title:
      "What are the different methods of fertility preservation available ?",
    content:
      "There are several methods for fertility preservation depending on individual needs. Egg freezing, or oocyte cryopreservation, involves the retrieval and freezing of a woman’s eggs for future use. Sperm freezing, or sperm cryopreservation, involves the collection and freezing of sperm. Embryo freezing, or embryo cryopreservation, involves fertilizing eggs with sperm and then freezing the resulting embryos. Ovarian tissue freezing, which is still considered experimental, involves removing and freezing ovarian tissue for future re-implantation. Testicular tissue freezing, also experimental, involves freezing testicular tissue that contains sperm.",
  },
  {
    title: "What is the process of egg freezing and sperm freezing ?",
    content:
      "The processes for egg and sperm freezing involve several steps. For egg freezing, ovarian stimulation is achieved using hormonal medications to produce multiple eggs. A minor surgical procedure is then performed to retrieve the mature eggs from the ovaries, which are then frozen using a process called vitrification. For sperm freezing, the sperm is collected through masturbation or surgical retrieval, analyzed and prepared for freezing, and then frozen using a cryoprotectant and stored in liquid nitrogen.",
  },
  {
    title:
      "How long can eggs, sperm, and embryos be stored, and what are the success rates after thawing ?",
    content:
      "Eggs, sperm, and embryos can be stored for many years without significant deterioration in quality. Typically, they can be stored for up to 10 years or longer, depending on local regulations and individual circumstances. The success rate for achieving pregnancy after thawing frozen eggs ranges from 30-50% per cycle, depending on the woman’s age at the time of freezing. Sperm freezing generally has high success rates, especially when used in assisted reproductive techniques like IVF or ICSI. Success rates for achieving pregnancy with frozen embryos are similar to those with fresh embryos, typically ranging from 40-60% per cycle.",
  },
  {
    title:
      "Are there any risks or side effects associated with fertility preservation ?",
    content:
      "Fertility preservation is generally safe, but there are potential risks and side effects associated with the different methods. For egg freezing, risks include ovarian hyperstimulation syndrome (OHSS), where the ovaries become swollen and painful after stimulation, and minor risks associated with the egg retrieval procedure. The emotional impact of undergoing fertility preservation should also be considered, and counseling is recommended if needed. Sperm freezing carries minimal risks as sperm collection is non-invasive. For embryo freezing, the risks are similar to those associated with egg freezing due to the same ovarian stimulation and egg retrieval process. Ovarian and testicular tissue freezing are experimental procedures with surgical risks and uncertainties regarding future use and success.",
  },
];

export default function CompleteWorkup() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cs_active');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.cs_reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>Fertility Preservation – Egg & Sperm Freezing Services</title>
        <meta name="description" content="Preserve your fertility with advanced egg and sperm freezing techniques, ideal before cancer treatment or delaying parenthood" />
        <meta name="keywords" content="fertility preservation, egg freezing, sperm freezing, preserve fertility" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/Fertility-Preservation" />
      </Helmet>
      <Container>
        <BannerSectionStyle3
          bgUrl="/images/Fertility-Preservation.jpeg"
          title="Welcome to <br /> Pluro Jabalpur<br /> Fertility Center"
          subTitle="Fertility Preservation"
        />

        {/* Intro Section */ }
        <Section topMd={ 160 } topLg={ 120 } topXl={ 80 }>
          <div className="container">
            <div className="cs_premium_intro_box" style={ { background: 'rgba(138, 74, 168, 0.03)', border: '1px solid rgba(138, 74, 168, 0.08)', borderRadius: '24px', padding: '40px' } }>
              <div className="row align-items-center cs_reveal cs_premium_intro_row">
                <div className="col-lg-5">
                  <div className="cs_intro_left">
                    <h1 className="cs_intro_title" style={ { fontSize: '32px' } }>
                      Preserve Your Fertility Options at <span style={ { color: '#c77842', fontWeight: '700' } }>Pluro Jabalpur Fertility Centre</span>
                    </h1>
                    <div className="cs_intro_divider"></div>
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="cs_intro_right">
                    <p className="mb-0">
                      Fertility preservation involves techniques that allow individuals to retain their reproductive potential for future use. At <span style={ { color: '#c77842', fontWeight: '700' } }>Pluro Jabalpur Fertility Centre</span>, recognized as the Best Fertility Clinic in Jabalpur, we offer comprehensive fertility preservation services under the expert guidance of Dr. Archana Shrivastava, the Best IVF Doctor in Jabalpur. Our mission is to provide personalized, compassionate care and empower individuals facing medical treatments or life circumstances that may impact their fertility.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Luxury Section for Why Consider */ }
        <div className="cs_luxury_section" style={ { paddingTop: '80px', marginTop: '80px' } }>
          <div className="organic-bg"></div>
          <div className="container relative z-10">
            <div className="cs_luxury_text_box cs_reveal">
              <h3>Why Consider Fertility Preservation ?</h3>
              <p>Fertility preservation may be considered in the following situations :</p>
            </div>

            <div className="cs_luxury_three_grid" style={ { marginTop: '50px' } }>
              <div className="cs_premium_service_card theme_purple cs_reveal cs_grid_item_span_2">
                <span className="cs_psc_number">01.</span>
                <h4>Medical Treatments</h4>
                <p>Individuals undergoing treatments such as chemotherapy or radiation therapy that may affect fertility.</p>
              </div>

              <div className="cs_premium_service_card theme_orange cs_reveal cs_grid_item_span_2">
                <span className="cs_psc_number">02.</span>
                <h4>Elective Reasons</h4>
                <p>Those choosing to delay childbearing due to personal or professional reasons.</p>
              </div>

              <div className="cs_premium_service_card theme_purple cs_reveal cs_grid_item_span_2">
                <span className="cs_psc_number">03.</span>
                <h4>Genetic Risks</h4>
                <p>Individuals with genetic conditions that may impact fertility later in life.</p>
              </div>

              <div className="cs_premium_service_card theme_orange cs_reveal cs_row_2_center_item_1">
                <span className="cs_psc_number">04.</span>
                <h4>Gender Transition</h4>
                <p>Transgender individuals undergoing hormone therapy that may affect fertility.</p>
              </div>

              <div className="cs_premium_service_card theme_purple cs_reveal cs_row_2_center_item_2">
                <span className="cs_psc_number">05.</span>
                <h4>Military Deployment</h4>
                <p>Military personnel facing deployment or other circumstances that may impact fertility.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Premium Design for Fertility Preservation Options */ }
        <Section topMd={ 120 } topLg={ 100 } topXl={ 80 }>
          <div className="container cs_reveal">
            <h3 className="text-center cs_fs_40 cs_medium mb-5" style={ { fontFamily: '"Playfair Display", serif', fontStyle: 'italic', color: '#1c2b38' } }>
              Fertility Preservation Options
            </h3>

            <div className="row justify-content-center cs_gap_y_40">
              {/* Egg Freezing */ }
              <div className="col-lg-6 col-md-6">
                <div className="cs_preservation_card_fx h-100" style={ { position: 'relative' } }>
                  <div style={ { position: 'absolute', top: '20px', right: '20px', background: 'rgba(255, 121, 15, 0.1)', color: '#ff790f', padding: '5px 15px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold' } }>
                    <FaFemale className="me-1" /> For Women
                  </div>
                  <div className="cs_wcp_icon">
                    <FaSnowflake style={ { fontSize: '32px', color: '#c77842' } } />
                  </div>
                  <h3>Egg Freezing (Oocyte Cryopreservation)</h3>
                  <p className="mb-2">Involves retrieving eggs from the ovaries, freezing them, and storing them for future use.</p>
                  <p>Recommended for women who wish to preserve their fertility due to medical treatments, age-related fertility decline, or personal choice.</p>
                </div>
              </div>

              {/* Embryo Freezing */ }
              <div className="col-lg-6 col-md-6">
                <div className="cs_preservation_card_fx h-100" style={ { position: 'relative' } }>
                  <div style={ { position: 'absolute', top: '20px', right: '20px', background: 'rgba(255, 121, 15, 0.1)', color: '#ff790f', padding: '5px 15px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold' } }>
                    <FaFemale className="me-1" /> For Women
                  </div>
                  <div className="cs_wcp_icon">
                    <FaSnowflake style={ { fontSize: '32px', color: '#c77842' } } />
                  </div>
                  <h3>Embryo Freezing (Embryo Cryopreservation)</h3>
                  <p className="mb-2">After eggs are retrieved and fertilized with sperm through IVF, resulting embryos can be frozen and stored for future use.</p>
                  <p>Suitable for couples undergoing IVF who wish to preserve embryos for future pregnancies.</p>
                </div>
              </div>

              {/* Ovarian Tissue Freezing */ }
              <div className="col-lg-6 col-md-6">
                <div className="cs_preservation_card_fx h-100" style={ { position: 'relative' } }>
                  <div style={ { position: 'absolute', top: '20px', right: '20px', background: 'rgba(255, 121, 15, 0.1)', color: '#ff790f', padding: '5px 15px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold' } }>
                    <FaFemale className="me-1" /> For Women
                  </div>
                  <div className="cs_wcp_icon">
                    <FaSnowflake style={ { fontSize: '32px', color: '#c77842' } } />
                  </div>
                  <h3>Ovarian Tissue Freezing</h3>
                  <p className="mb-2">Involves removing and freezing ovarian tissue containing immature eggs, which can be later transplanted back or matured in the laboratory.</p>
                  <p>Considered for prepubescent girls or women who cannot undergo ovarian stimulation.</p>
                </div>
              </div>

              {/* Sperm Freezing */ }
              <div className="col-lg-6 col-md-6">
                <div className="cs_preservation_card_fx h-100" style={ { position: 'relative' } }>
                  <div style={ { position: 'absolute', top: '20px', right: '20px', background: 'rgba(16, 161, 157, 0.1)', color: '#10a19d', padding: '5px 15px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold' } }>
                    <FaMale className="me-1" /> For Men
                  </div>
                  <div className="cs_wcp_icon">
                    <FaSnowflake style={ { fontSize: '32px', color: '#c77842' } } />
                  </div>
                  <h3>Sperm Freezing (Sperm Cryopreservation)</h3>
                  <p className="mb-2">Collection and freezing of sperm samples for later use in assisted reproductive techniques such as IVF or ICSI.</p>
                  <p>Recommended for men facing medical treatments or other circumstances that may impact sperm quality or production.</p>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Working Process Sections */ }
        <Section topMd={ 120 } topLg={ 100 } topXl={ 80 }>
          <WorkingProcess
            sectionTitle="Egg Freezing Process"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ workingProcessData }
          />
        </Section>

        <Section topMd={ 80 } topLg={ 60 } topXl={ 40 }>
          <WorkingProcess
            sectionTitle="Sperm Freezing Process"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ workingProcessData1 }
          />
        </Section>

        <Section topMd={ 80 } topLg={ 60 } topXl={ 40 }>
          <WorkingProcess
            sectionTitle="Embryo Freezing Process"
            sectionTitleUp=""
            sectionTitleDown=""
            sectionSubTitle=""
            data={ workingProcessData2 }
          />
        </Section>

        {/* Benefits Section */ }
        <Section topMd={ 120 } topLg={ 100 } topXl={ 80 }>
          <div className="container cs_reveal">
            <h2 className="text-center cs_fs_40 cs_medium mb-5" style={ { fontFamily: '"Playfair Display", serif', fontStyle: 'italic' } }>Benefits of Fertility Preservation</h2>
            <div className="row cs_gap_y_40 justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="cs_why_card_premium h-100">
                  <div className="cs_wcp_icon">
                    <FaRegClock style={ { fontSize: '32px', color: '#ff790f' } } />
                  </div>
                  <h3>Preserve Reproductive Options</h3>
                  <p>Allows individuals to delay parenthood while maintaining the possibility of biological children in the future.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="cs_why_card_premium h-100">
                  <div className="cs_wcp_icon">
                    <FaShieldAlt style={ { fontSize: '32px', color: '#ff790f' } } />
                  </div>
                  <h3>Peace of Mind</h3>
                  <p>Provides reassurance for those facing medical treatments or life circumstances that may impact fertility.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="cs_why_card_premium h-100">
                  <div className="cs_wcp_icon">
                    <FaSnowflake style={ { fontSize: '32px', color: '#ff790f' } } />
                  </div>
                  <h3>Advanced Technology</h3>
                  <p>Utilizes state-of-the-art techniques to safely freeze and store reproductive cells.</p>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* Why Choose Us Section */ }
        <Section topMd={ 120 } topLg={ 100 } topXl={ 80 } bottomMd={ 80 } bottomLg={ 60 } bottomXl={ 40 }>
          <div className="container cs_reveal">
            <div className="cs_premium_why_choose">
              <div className="cs_premium_section_header">
                <h2>Why Choose Pluro Jabalpur Fertility Centre for Fertility Preservation ?</h2>
              </div>

              <div className="row cs_gap_y_40 justify-content-center" style={ { display: 'flex', flexWrap: 'wrap' } }>
                <div className="col-lg-4 col-md-6">
                  <div className="cs_why_card_premium h-100">
                    <div className="cs_wcp_icon">
                      <FaUserMd style={ { fontSize: '32px', color: '#ff790f' } } />
                    </div>
                    <h3>Expertise and Experience</h3>
                    <p>Led by Dr. Archana Shrivastava, our team has extensive experience in fertility preservation techniques.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="cs_why_card_premium h-100">
                    <div className="cs_wcp_icon">
                      <FaHeart style={ { fontSize: '32px', color: '#ff790f' } } />
                    </div>
                    <h3>Personalized Care</h3>
                    <p>We understand the sensitive nature of fertility preservation and tailor our services to meet your unique needs.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="cs_why_card_premium h-100">
                    <div className="cs_wcp_icon">
                      <FaClinicMedical style={ { fontSize: '32px', color: '#ff790f' } } />
                    </div>
                    <h3>Comprehensive Fertility Services</h3>
                    <p>From initial consultation and fertility assessment to advanced procedures and long-term storage, we offer complete fertility preservation solutions.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium h-100">
                    <div className="cs_wcp_icon">
                      <FaHospital style={ { fontSize: '32px', color: '#ff790f' } } />
                    </div>
                    <h3>State-of-the-Art Facility</h3>
                    <p>Equipped with the latest technology and facilities to ensure the highest standards of care and storage.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="cs_why_card_premium h-100">
                    <div className="cs_wcp_icon">
                      <FaStethoscope style={ { fontSize: '32px', color: '#ff790f' } } />
                    </div>
                    <h3>Supportive Environment</h3>
                    <p>We provide compassionate support throughout your fertility preservation journey, prioritizing your comfort and well-being.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        {/* FAQ Section */ }
        <Section topMd={ 40 } topLg={ 20 } topXl={ 0 }>
          <div className="cs_iui_faq_wrapper cs_reveal">
            <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={ faqData }
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
          </div>
        </Section>

        {/* Contact Us Section */ }
        <Section topMd={ 60 } topLg={ 40 } topXl={ 20 } bottomMd={ 100 } bottomLg={ 80 } bottomXl={ 60 }>
          <div className="container cs_reveal">
            <div className="cs_ivf_contact_banner" style={ { background: '#c77842', borderRadius: '20px', padding: '60px 50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '30px' } }>
              <div className="cs_icc_content" style={ { flex: '1', minWidth: '300px' } }>
                <h2 style={ { color: '#fff', fontSize: '36px', marginBottom: '15px', fontWeight: '700' } }>Contact Us</h2>
                <p style={ { color: 'rgba(255,255,255,0.9)', fontSize: '18px', margin: '0', lineHeight: '1.6' } }>
                  If you are considering fertility preservation, contact Pluro Jabalpur Fertility Centre today. Our dedicated team is here to provide guidance, support, and expertise to help you preserve your fertility and achieve your future family goals.
                </p>
              </div>
              <div className="cs_icc_action">
                <Link to="/contact" className="cs_btn" style={ { background: '#fff', color: '#c77842', padding: '15px 40px', borderRadius: '50px', fontWeight: '600', fontSize: '18px', display: 'inline-flex', alignItems: 'center', textDecoration: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' } }>
                  <span>Get in Touch</span>
                </Link>
              </div>
            </div>
          </div>
        </Section>

        <Section bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <div className="container cs_reveal">
            <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
            <Spacing md="57" />
            <div className="row cs_gap_y_40">
              { relatedBlog?.map((item, index) => (
                <div className="col-xl-12" key={ index }>
                  <Post { ...item } />
                </div>
              )) }
            </div>
          </div>
        </Section>
      </Container>
    </>
  );
}

const Container = styled.div`
  .margin {
    margin-left: 25px;
  }
  .heading{
    font-size: 32px;
     @media (max-width: 991px) {
      font-size: 28px;
    }
  }
  
  .cs_options_card_custom:hover {
    box-shadow: 0 15px 35px rgba(0,0,0,0.05) !important;
    transform: translateY(-5px);
  }
`;
